var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewZealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_1911)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_1911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_1911)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7353 15.4696L12.2843 17.1873L13.9748 16.5459L12.9746 18.0571L14.5293 18.9757L12.73 19.1333L12.9801 20.9217L11.7353 19.6117L10.485 20.9217L10.7351 19.1333L8.93585 18.9757L10.4905 18.0571L9.4903 16.5459L11.1808 17.1873L11.7353 15.4696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4607 5.8103L26.7216 6.62566L27.5316 6.32126L27.0532 7.03878L27.7925 7.47907L26.9336 7.55517L27.0532 8.40859L26.4607 7.78348L25.8682 8.40859L25.9878 7.55517L25.129 7.47907L25.8682 7.03878L25.3899 6.32126L26.1944 6.62566L26.4607 5.8103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3V3.95126L18.1386 11.5178H20.0411V10.5666L4.90795 3H3ZM20.0466 3V3.95126L4.90795 11.5233H3V10.572L18.1386 3H20.0466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1045 3V11.5233H12.9474V3H10.1045ZM3 5.8429V8.68581H20.0411V5.8429H3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.40822V8.11505H20.0411V6.40822H3ZM10.6699 3V11.5233H12.3767V3H10.6699Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3584 3H4.64704C3.73926 3 3 3.73926 3 4.64704V22.2209C3 23.1286 3.73926 23.8679 4.64704 23.8679H31.3529C32.2607 23.8679 33 23.1232 33 22.2209V4.64704C33.0054 3.73926 32.2607 3 31.3584 3Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12502 4.01649L18.1386 11.5233H20.0411V10.572L4.90795 3H4.64704C3.96757 3 3.37507 3.41855 3.12502 4.01649ZM20.0466 3V3.95126L4.90795 11.5233H3V10.572L18.1386 3H20.0466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1045 3V11.5233H12.9474V3H10.1045ZM3 5.8429V8.68581H20.0411V5.8429H3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.40822V8.11505H20.0411V6.40822H3ZM10.6699 3V11.5233H12.3767V3H10.6699Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.5233L8.68037 8.68037H9.95234L4.27197 11.5233H3ZM3.26092 3.76644C3.36963 3.59793 3.50553 3.45117 3.66316 3.33158L8.68581 5.8429H7.41384L3.26092 3.76644ZM13.0942 5.8429L18.7746 3H20.0466L14.3607 5.8429H13.0942ZM20.0466 11.5233L14.3607 8.68037H15.6327L20.0411 10.8873V11.5233H20.0466Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5096 6.9681V7.62583L27.8197 6.9681H26.5096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7597 7.73998L26.3738 7.21271L27.8197 6.9681L26.7597 7.73998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5097 6.9681V7.62583L25.1996 6.9681H26.5097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2596 7.73998L26.6456 7.21271L25.1996 6.9681L26.2596 7.73998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9173 7.26707L26.2922 7.4682L27.3196 8.51186L26.9173 7.26707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2596 7.73998L26.6456 7.21272L27.3196 8.51186L26.2596 7.73998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.102 7.26707L26.7271 7.46819L26.5097 6.01684L26.102 7.26707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9173 7.26707L26.2922 7.46819L26.5097 6.01684L26.9173 7.26707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.102 7.26707L26.7271 7.4682L25.6998 8.51186L26.102 7.26707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7597 7.73998L26.3738 7.21272L25.6998 8.51186L26.7597 7.73998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5096 7.11488V7.54974L27.3739 7.11488H26.5096Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6727 7.62584L26.4172 7.27251L27.3739 7.11488L26.6727 7.62584Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5097 7.11488V7.54974L25.6454 7.11488H26.5097Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3466 7.62584L26.5966 7.27251L25.6454 7.11488L26.3466 7.62584Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.776 7.31055L26.3629 7.44101L27.0424 8.13135L26.776 7.31055Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3466 7.62582L26.5966 7.2725L27.0423 8.13135L26.3466 7.62582Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2433 7.31056L26.651 7.44102L26.5097 6.48433L26.2433 7.31056Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.776 7.31056L26.3629 7.44102L26.5097 6.48433L26.776 7.31056Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2433 7.31055L26.651 7.44101L25.9716 8.13135L26.2433 7.31055Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6728 7.62582L26.4173 7.2725L25.9716 8.13135L26.6728 7.62582Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9397 10.0013V10.5829L31.1084 10.0013H29.9397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1625 10.6862L29.82 10.2133L31.1083 10.0013L30.1625 10.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9397 10.0013V10.5829L28.7764 10.0013H29.9397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7168 10.6862L30.0647 10.2133L28.7764 10.0013L29.7168 10.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3038 10.2622L29.7494 10.4415L30.6626 11.3711L30.3038 10.2622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7168 10.6862L30.0647 10.2132L30.6626 11.3711L29.7168 10.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5809 10.2622L30.1353 10.4416L29.9396 9.15329L29.5809 10.2622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3038 10.2622L29.7494 10.4416L29.9396 9.15329L30.3038 10.2622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5809 10.2622L30.1353 10.4415L29.2221 11.3711L29.5809 10.2622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1625 10.6862L29.82 10.2132L29.2221 11.3711L30.1625 10.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9397 10.148V10.5068L30.6627 10.148H29.9397Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.081 10.572L29.869 10.2785L30.6626 10.148L30.081 10.572Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9396 10.148V10.5068L29.2221 10.148H29.9396Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8037 10.572L30.0157 10.2785L29.2221 10.148L29.8037 10.572Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1679 10.3057L29.82 10.4198L30.3908 10.996L30.1679 10.3057Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8038 10.572L30.0158 10.2785L30.3908 10.996L29.8038 10.572Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7168 10.3057L30.0647 10.4198L29.9397 9.62075L29.7168 10.3057Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1679 10.3057L29.82 10.4198L29.9396 9.62075L30.1679 10.3057Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7168 10.3057L30.0647 10.4198L29.4939 10.996L29.7168 10.3057Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.081 10.572L29.869 10.2785L29.4939 10.996L30.081 10.572Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5035 11.0014V11.6537L23.8136 11.0014H22.5035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7536 11.7679L22.3676 11.2406L23.8135 11.0014L22.7536 11.7679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5035 11.0014V11.6537L21.1935 11.0014H22.5035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2535 11.7679L22.6394 11.2406L21.1935 11.0014L22.2535 11.7679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9112 11.295L22.2861 11.4961L23.3134 12.5398L22.9112 11.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2535 11.7679L22.6394 11.2406L23.3135 12.5398L22.2535 11.7679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1013 11.295L22.7209 11.4961L22.5035 10.0447L22.1013 11.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9112 11.295L22.2861 11.4961L22.5035 10.0447L22.9112 11.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1013 11.295L22.721 11.4961L21.6936 12.5398L22.1013 11.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7536 11.7679L22.3676 11.2406L21.6936 12.5398L22.7536 11.7679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5035 11.1428V11.5776L23.3733 11.1428H22.5035Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.672 11.6537L22.4165 11.3004L23.3732 11.1428L22.672 11.6537Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5035 11.1428V11.5776L21.6392 11.1428H22.5035Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3404 11.6537L22.5959 11.3004L21.6392 11.1428L22.3404 11.6537Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7699 11.3385L22.3622 11.4743L23.0417 12.1647L22.7699 11.3385Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3404 11.6537L22.5959 11.3004L23.0416 12.1647L22.3404 11.6537Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2372 11.3385L22.6503 11.4744L22.5035 10.5122L22.2372 11.3385Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7699 11.3385L22.3622 11.4744L22.5035 10.5122L22.7699 11.3385Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2372 11.3385L22.6503 11.4743L21.9708 12.1647L22.2372 11.3385Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.672 11.6537L22.4166 11.3004L21.9708 12.1647L22.672 11.6537Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5096 17.3232V18.0516L27.9664 17.3232H26.5096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7869 18.1766L26.3575 17.5896L27.9665 17.3232L26.7869 18.1766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5096 17.3232V18.0516L25.0529 17.3232H26.5096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2324 18.1766L26.6618 17.5896L25.0529 17.3232L26.2324 18.1766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9609 17.6494L26.2651 17.8777L27.412 19.0355L26.9609 17.6494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2324 18.1766L26.6618 17.5896L27.412 19.0355L26.2324 18.1766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0585 17.6494L26.7543 17.8777L26.5097 16.2633L26.0585 17.6494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9609 17.6494L26.2651 17.8777L26.5097 16.2633L26.9609 17.6494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0585 17.6494L26.7542 17.8777L25.6073 19.0355L26.0585 17.6494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7869 18.1766L26.3574 17.5896L25.6073 19.0355L26.7869 18.1766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5096 17.47V17.9701L27.5207 17.47H26.5096Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 18.0625L26.4064 17.6548L27.5208 17.47L26.7 18.0625Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5097 17.47V17.9701L25.4987 17.47H26.5097Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.314 18.0625L26.613 17.6548L25.4987 17.47L26.314 18.0625Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8195 17.6929L26.3411 17.8505L27.1347 18.655L26.8195 17.6929Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.314 18.0625L26.6129 17.6548L27.1348 18.655L26.314 18.0625Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1944 17.6929L26.6782 17.8505L26.5097 16.7307L26.1944 17.6929Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8195 17.6929L26.3411 17.8505L26.5096 16.7307L26.8195 17.6929Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1944 17.6929L26.6781 17.8505L25.8845 18.655L26.1944 17.6929Z",
    fill: "#C7202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6999 18.0625L26.4064 17.6548L25.8845 18.655L26.6999 18.0625Z",
    fill: "#C7202F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_1911",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_1911"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_1911",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewZealand);
export default __webpack_public_path__ + "static/media/NewZealand.39609d63bae362a3edf11c14fa1dbe7b.svg";
export { ForwardRef as ReactComponent };